import { AfterViewInit, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { take } from "rxjs/operators";
import { Map, Marker } from "leaflet";
import { Subject } from "rxjs";

declare var L: {
  Map: new (arg0: string, arg1: any) => Map;
  marker: (
    arg0: number[],
    arg1: { draggable: boolean; autoPan: boolean }
  ) => { (): any; new (): any; addTo: { (arg0: Map): Marker<any>; new (): any } };
  control: { attribution: (arg0: { position: string }) => any };
  DomUtil: { create: (arg0: string, arg1: string) => any };
  popup: (arg0: { className: string }) => { (): any; new (): any; setContent: { (arg0: string): any; new (): any } };
};

export interface MapConfirmValue {
  lng: number;
  lat: number;
  formattedAddress: string;
}

@Component({
  selector: "ngx-map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.scss"],
})
export class MapComponent extends BaseFormComponent<any> implements AfterViewInit {
  marker: L.Marker<any>;
  myMap: L.Map;
  lng: number;
  lat: number;
  formattedAddress: string;
  confirmValue: Subject<MapConfirmValue>;

  currentBranch = this.accountService.authService.currentBranch;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, public http: HttpClient) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    // Get the modal and close button elements
    this.apiName = "";
    this.areaName = "";
    this.label = "";
    this.server();
    this.modal();
  }

  server() {
    const MapApiKey = "web.f29442ca11e04fdbb1f8d4c7d003c195";

    const defaultLat = this.lat ?? this.currentBranch?.Latitude ?? 35.699512108037005;
    const defaultLng = this.lng ?? this.currentBranch?.Longitude ?? 51.33773794397673;

    this.myMap = new L.Map("map", {
      key: MapApiKey,
      maptype: "neshan",
      poi: true,
      traffic: false,
      center: [defaultLat, defaultLng],
      zoom: 16,
    } as any);

    this.myMap.on("popupopen", () => {
      const confirmButton = document.getElementById("confirmButton");
      confirmButton.addEventListener("click", () => {
        this.confirmValue?.next({
          formattedAddress: this.formattedAddress,
          lat: this.lat,
          lng: this.lng,
        });
        this.closeModal();
      });
    });

    this.marker = L.marker([defaultLat, defaultLng], {
      draggable: true,
      autoPan: true,
    }).addTo(this.myMap);

    const legend = L.control.attribution({ position: "bottomleft" });
    legend.onAdd = function () {
      const div = L.DomUtil.create("div", "info legend");

      let labels = [
        "<div style='display: flex; justify-content: center; align-items: center; flex-direction: column; margin-top: -65px; margin-bottom: 20px; margin-left: 3px'>",
        "<img src='assets/imgs/sepidz-tr.png' alt='Logo' style='width: 40px; height: 40px;'>",
        "</div>",
      ];
      div.innerHTML = labels.join("");
      return div;
    };
    legend.addTo(this.myMap);
    this.marker.on("dragend", this.onMarkerDragEnd.bind(this));

    this.myMap.on("click", (e: any) => {
      const latLng = e.latlng;
      this.marker.setLatLng(latLng);
      this.onMarkerDragEnd();
    });

    if (this.formattedAddress) {
      const address = document.getElementById("address") as any;
      address.value = this.formattedAddress;
    }
  }

  onMarkerDragEnd() {
    const markerLatLng = this.marker.getLatLng();
    this.reverseGeocoding(markerLatLng.lat, markerLatLng.lng);
  }

  reverseGeocoding(lat: number, lng: number) {
    const url = `https://api.neshan.org/v5/reverse?lat=${lat}&lng=${lng}`;
    const ApiKey = "service.1d2a513bc1c148618f821b3ae2df7de1";
    let headers = new HttpHeaders({ "Content-Type": "application/json", "Api-Key": ApiKey });
    this.http
      .get(url, { headers })
      .pipe(take(1))
      .subscribe(
        (data: any) => {
          const address = document.getElementById("address") as any;
          address.value = data.formatted_address;
          this.formattedAddress = address.value;

          this.lng = lng;
          this.lat = lat;

          const popupContent =
            "<div class='rtl-popup'>" +
            address.value +
            "</div><p style='color: navy;'>Lat: " +
            lat +
            "<br>Lng: " +
            lng +
            "</p>" +
            "<button id='confirmButton'>" +
            this.translate("ClientApp.FrontOffice.Parties.Map.Confirmation") +
            "</button>";
          const popup = L.popup({ className: "custom-popup" }).setContent(popupContent);
          this.marker.bindPopup(popup).openPopup();
        },
        (err) => {
          console.log("error = " + err);
        }
      );
  }

  geocoding() {
    const address = (document.getElementById("address") as any)?.value;
    const url = `https://api.neshan.org/v4/geocoding?address=${address}`;
    const ApiKey = "service.1d2a513bc1c148618f821b3ae2df7de1";
    let headers = { "Api-Key": ApiKey };

    this.http
      .get(url, { headers })
      .pipe(take(1))
      .subscribe(
        (data: any) => {
          let status = data.status;
          if (status == "NO_RESULT") this.sts.showToast("warning", "", this.translate("ClientApp.FrontOffice.Parties.Map.DesiredAddressNotFound"));

          if (status == "OK") {
            const lat = data.location.y;
            const lng = data.location.x;
            this.lng = lng;
            this.lat = lat;
            this.formattedAddress = address;
            const popupContent =
              "<div class='rtl-popup'>" +
              address +
              "</div><p style='color: navy;'>Lat: " +
              lat +
              "<br>Lng: " +
              lng +
              "</p> " +
              "<button id='confirmButton'>" +
              this.translate("ClientApp.FrontOffice.Parties.Map.Confirmation") +
              "</button>";
            const popup = L.popup({ className: "custom-popup" }).setContent(popupContent);
            this.marker.setLatLng([lat, lng]);
            this.marker.bindPopup(popup).openPopup();
            this.myMap.flyTo([lat, lng], 15);
          }
        },
        (err) => {
          console.log("error = " + err);
          this.marker.remove();
        }
      );
  }

  onAddressKeyPress($event: any) {
    if ($event.keyCode == 13 || $event.which == 13) this.geocoding();
  }

  private modal() {
    const modal = document.getElementById("myModal");
    const closeButton = document.querySelector(".close");
    const openModalButton = document.getElementById("openModalBtn");
    function openModal() {
      modal.style.display = "flex";
    }
    function closeModal() {
      modal.style.display = "none";
    }
    openModalButton.addEventListener("click", openModal.bind(this));
    closeButton.addEventListener("click", closeModal.bind(this));
    closeButton.addEventListener("click", closeModal.bind(this));
    window.addEventListener("click", function (event) {
      if (event.target === modal) closeModal();
    });
    modal.addEventListener("click", function (event) {
      if (event.target === modal) closeModal();
    });
  }
}
